const tsDataReading = {
  scale1: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  scale2: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757952381
  },
  scale3: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  scale4: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175779487
  },
  scale5: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  scale6: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175729944
  },
  scale7: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175753086
  },
  scale8: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.03617571978
  },
  scale9: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  scale10: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175747462
  },
  scale11: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175752855
  },
  scale12: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175709672
  },
  scale13: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175783236
  },
  scale14: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.03617575553
  },
  scale15: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757217
  },
  scale16: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175760871
  },
  scale17: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175757761
  },
  scale18: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.03617571151
  },
  scale19: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.03617574736
  },
  scale20: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175701014
  },
  scale21: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175731085
  },
  scale22: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175772675
  },
  scale23: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175700332
  },
  scale24: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.03617570566
  },
  scale25: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175723977
  },
  scale26: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175705797
  },
  scale27: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175738375
  },
  scale28: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175752941
  },
  scale29: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175719355
  },
  scale30: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175744444
  },
  scale31: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175753488
  },
  scale32: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.03617575679
  },
  scale33: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  scale34: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.036175742029
  },
  scale35: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  scale36: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  }
}

export default tsDataReading
